import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=88072a40&lang=pug&"
import script from "./ColorPicker.vue?vue&type=script&setup=true&lang=js&"
export * from "./ColorPicker.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=88072a40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports